 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		9: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","1":"default~modules-admin-catalog-catalog-module~modules-admin-cms-cms-module~modules-admin-contest-cont~6de06866","2":"default~modules-admin-catalog-catalog-module~modules-admin-cms-cms-module~modules-admin-corporate-gi~0398a9ca","3":"default~modules-admin-catalog-catalog-module~modules-admin-corporate-gift-corporate-gift-module~modu~3f71ed43","4":"default~modules-admin-catalog-catalog-module~modules-admin-e-commerce-product-e-commerce-product-mod~a6bd66ee","5":"default~modules-admin-cms-cms-module~modules-admin-employee-employee-module~modules-admin-enquiry-en~f0563ab5","6":"default~modules-admin-customer-details-customer-details-module~modules-admin-employee-employee-modul~d4478921","7":"default~modules-admin-catalog-catalog-module~modules-admin-corporate-gift-corporate-gift-module~modu~99645182","8":"default~modules-admin-sessions-sessions-module~modules-admin-settings-settings-module~modules-employ~b18f4cd8","10":"default~modules-admin-dashboard-dashboard-module~modules-employee-dashboard-dashboard-module","11":"default~modules-admin-photoframe-photoframe-module~modules-admin-selfie-album-selfie-album-module","12":"firebase-auth","13":"firebase-messaging","15":"modules-admin-billing-management-billing-management-module","16":"modules-admin-cancelled-details-cancelled-details-module","17":"modules-admin-catalog-catalog-module","18":"modules-admin-cms-cms-module","19":"modules-admin-commission-transaction-commission-transaction-module","20":"modules-admin-contest-contest-module","21":"modules-admin-corporate-gift-corporate-gift-module","22":"modules-admin-customer-details-customer-details-module","23":"modules-admin-dashboard-dashboard-module","24":"modules-admin-delivery-details-delivery-details-module","25":"modules-admin-e-commerce-product-e-commerce-product-module","26":"modules-admin-employee-employee-module","27":"modules-admin-enquiry-enquiry-module","28":"modules-admin-leads-leads-module","29":"modules-admin-management-communication-management-communication-module","30":"modules-admin-notification-notification-module","31":"modules-admin-passportsizephoto-passportsizephoto-module","32":"modules-admin-payment-payment-module","33":"modules-admin-photo-print-photo-print-module","34":"modules-admin-photoframe-photoframe-module","35":"modules-admin-quote-quote-module","36":"modules-admin-refund-refund-module","37":"modules-admin-reports-customer-report-customer-report-module","38":"modules-admin-reports-employee-report-employee-report-module","39":"modules-admin-reports-gst-report-gst-report-module","40":"modules-admin-reports-payments-payments-module","41":"modules-admin-reports-product-report-product-report-module","42":"modules-admin-reports-refund-order-refund-order-module","43":"modules-admin-reports-reports-module","44":"modules-admin-reports-review-report-review-report-module","45":"modules-admin-reports-sales-report-sales-report-module","46":"modules-admin-reports-stock-report-stock-report-module","47":"modules-admin-reports-task-report-task-report-module","48":"modules-admin-reports-ticket-report-ticket-report-module","49":"modules-admin-selfie-album-selfie-album-module","50":"modules-admin-sessions-sessions-module","51":"modules-admin-settings-designation-designation-module","52":"modules-admin-settings-settings-module","53":"modules-admin-task-manager-task-manager-module","54":"modules-admin-test-personalized-test-personalized-module","55":"modules-admin-ticket-ticket-module","56":"modules-admin-track-order-track-order-module","57":"modules-admin-waiting-cod-waiting-cod-module","58":"modules-admin-waiting-dispatch-waiting-dispatch-module","59":"modules-admin-waiting-payments-waiting-payments-module","60":"modules-employee-change-password-change-password-module","61":"modules-employee-dashboard-dashboard-module","62":"modules-employee-employee-task-manager-employee-task-manager-module","63":"modules-employee-enquiry-enquiry-module","64":"modules-employee-notification-notification-module","65":"modules-employee-quote-quote-module","66":"modules-employee-sessions-sessions-module"}[chunkId]||chunkId) + "-es2015." + {"0":"a2ef4a133259f66b115e","1":"c0cb157238ef2be7eb60","2":"8b427a51ee194c365136","3":"9170e86c3b8817a4495e","4":"5d2fd5e2044d30571124","5":"0c9258792a25f96d1b02","6":"8ad9d59884c5c020d695","7":"59feb31d2bfd711051a7","8":"933b415c912a7af523f8","10":"bb06926d5dec70db0082","11":"0c52ebf027e9c460d2a2","12":"581c8197e252c66836d2","13":"11f9c63d87cccf6ef1d9","15":"d36f337a8abf12b6542d","16":"969613cfc087e65073e6","17":"3887281776c04dc2a550","18":"9349ed790908cbb7f0b7","19":"2048bef6164342dc002c","20":"26a063d4ce5591cbebf0","21":"b1313f6ef772934bd2dd","22":"e80b05e499f1b61b026a","23":"6ad2524c07c783db9198","24":"736a57473fe46262b945","25":"3e94892385db438c5419","26":"1d21d9fce197cecfc5ea","27":"52d1c0274a970e2bde92","28":"d06ad43e07965d6b50e6","29":"4754bd67686ebfcaba2a","30":"a8da9657ff89dac3215d","31":"8c301ce8f9e683f9bb0b","32":"f10e45b047ea25c9ac5e","33":"efbddd489c838c1c2c97","34":"ec08a8d2856157c47078","35":"4622290af491f1821d8b","36":"a299e140305c5990a505","37":"cca2cca9f126e3917a87","38":"73d11e32db791483593b","39":"b4eafb803b37e9f17e17","40":"1129b202c878423bc57a","41":"20c9bf3d28b5d8aee0cd","42":"1b4ab367a18df97d098e","43":"94a94e9608493e2cda6c","44":"33295ca0206509de8bd8","45":"6dfe0339ebfcaa77b81b","46":"8a8dc2633371e8b0253c","47":"69a4ada63cc2d060665e","48":"dd167bb14c70884b0505","49":"71d4e7952a263e3fee30","50":"4b6bfddba967610dbc50","51":"9da088d799c7b5e1c993","52":"9a7a44c6eab798ae7054","53":"7c94602bf51725f0d76d","54":"d3a6048975f99e500606","55":"4c6aeb50f9cbae1efc7d","56":"4c94ca42443f7d37afdd","57":"22dcc2951af36a2d5537","58":"30723e868f5a0bf9c70c","59":"908edce848b94a3ace00","60":"e31d60dd129f12859600","61":"c451fb9d9b3f08bc26ce","62":"b7600e6f00eadb424884","63":"4adf9ea89917e0e85919","64":"ee9640bbf0bc9c48f7ae","65":"4750578f9a61cd0a9f62","66":"e5c2c7a9e5842511a648"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
